import React from 'react';

export const Modal = ({ onClose, children }: { onClose: () => void; children: React.ReactNode }) => (
  <div
    className="fixed inset-0 z-[500] flex animate-overlay-in items-center justify-center bg-brand-bg/75 p-4 backdrop-blur-md"
    onClick={onClose}
  >
    <div
      className="max-h-[90vh] w-full max-w-[520px] animate-card-in overflow-y-auto rounded-[1.25rem] border border-brand-teal/20 bg-[rgba(10,16,32,0.95)] shadow-[0_32px_64px_rgba(0,0,0,0.6),0_0_80px_rgba(70,192,186,0.06)]"
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  </div>
);

export const ModalHeader = ({ title, onClose }: { title: string; onClose: () => void }) => (
  <div className="flex items-center justify-between border-b border-brand-teal/10 px-6 pt-6 pb-4">
    <h2 className="m-0 text-lg font-bold text-white">{title}</h2>
    <button
      className="flex h-6 w-6 items-center justify-center text-lg leading-none text-white/40 transition-colors duration-200 hover:text-brand-danger cursor-pointer"
      onClick={onClose}
    >
      ✕
    </button>
  </div>
);

export const ModalBody = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col gap-[1.1rem] px-6 py-5">{children}</div>
);

export const ModalFooter = ({ children }: { children: React.ReactNode }) => (
  <div className="flex gap-3 border-t border-brand-teal/8 px-6 pt-4 pb-6">{children}</div>
);
